<div class="context-menu" (click)="toggleMenu(); $event.stopPropagation()">
  <!-- <qds-icon class="qds-icon" name="dots-3-vertical" size="small"></qds-icon> -->
  <qds-button
    #contextMenuBtn
    id="contextMenu"
    icon-name="dots-3-vertical"
    icon-only="true"
    size="small"
    importance="subdued"
    title="More"
  ></qds-button>
  <!-- <qds-tooltip target="#contextMenu"  trigger="pointerenter"  placement="bottom"> More </qds-tooltip> -->
</div>

<div *ngIf="isVisible" class="device-info-popup">
  <div class="device-info-popup-container">
    <div class="device-info-popup-content">
      <qds-button
        *ngIf="item?.deviceType === 'AIREdge' && role == roles.enduser && item?.assignedInstallerId === null"
        importance="emphasized"
        icon-name="person-gear"
        text="Share Device"
        (click)="onShareDevice()"
      ></qds-button>
      <qds-button *ngIf="item?.deviceType === 'AIREdge' && role == roles.enduser && item?.assignedInstallerId" importance="destructive" icon-name="person-gear" text="Stop Share Device" (click)="onShareDevice()"></qds-button>

      <qds-button
        *ngIf="role === roles.enduser && item?.deviceType === 'REX' && !item.remoteLink"
        importance="emphasized"
        icon-name="person-computer-screen"
        text="Add Remote Link"
        (click)="addUpdateRemoteLink(item)"
      ></qds-button>
      <qds-button
        *ngIf="role === roles.enduser && item?.deviceType === 'REX' && item.remoteLink"
        importance="emphasized"
        icon-name="person-computer-screen"
        text="Update Remote Link"
        (click)="addUpdateRemoteLink(item)"
      ></qds-button>
      <qds-button
        *ngIf="role === roles.installer && item?.deviceType === 'AIREdge'"
        importance="destructive"
        icon-name="circle-slash-within"
        text="Revoke Device"
        (click)="revokeDeviceModal(item)">
      </qds-button>

      <div *ngIf="item?.deviceType === 'AIREdge' && role == roles.enduser" class="device-info-divider"></div>
      <div class="device-info-row">
        <qds-list-item kicker="Owner Name" [text]="item?.ownerName"></qds-list-item>
      </div>
      <div class="device-info-row">
        <qds-list-item kicker="Software Version" [subtitle]="item?.firmwareVersion ? '' : 'NA'" [text]="item?.firmwareVersion"></qds-list-item>
      </div>
      <div class="device-info-link-row">
        <div class="device-info-link-container">
          <div class="device-info-link">
            <span>
              <!-- <qds-label text="Technical Document Link" importance="standard"></qds-label> -->
              <a href="https://www.eliwell.com/en/" target="_blank" rel="noopener noreferrer">
                Technical Document Link
              </a>
              <qds-icon class="qds-icon" name="arrow-top-right-on-square" iconLibrary="default"></qds-icon>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="se-dialog" *ngIf="isDialogOpen">
  <div class="se-dialog-holder">
    <div class="se-complex-header">
      <!-- <h3 class="se-dialiog-title">{{item?.name}} </h3> -->
      <qds-title *ngIf="!item?.assignedInstallerId" slot="title" layer="popup" [subtitle]="item?.name" level="root"> Share Device </qds-title>
      <qds-title *ngIf="item?.assignedInstallerId" slot="title" layer="popup" [subtitle]="item?.name" level="root">Stop Share Device </qds-title>
      <!-- <qds-list-item slot="title" layer="popup" size="large" level="root" [subtitle]="item?.name" text="Share Device" showDivider="true"></qds-list-item> -->
      <qds-divider class="w-full" importance="standard" vertical="false" style="margin-top: 10px"></qds-divider>
    </div>
    <div class="se-dialog-body">
      <div class="email-field w-full">
        <qds-label text="Installer Email" required="true"></qds-label>
        <qds-input *ngIf="!item?.assignedInstallerId"
          type="email"
          class="txtSearch"
          size="standard"
          placeholder="Enter Email"
          class="w-full emailText"
          [value]="installerEmail"
          (qdsChange)="onCheckEmail($event)"
          style="--qds-theme-input-background: #222222; --qds-color-background-primary: #222222"
        ></qds-input>
        <qds-label *ngIf="item?.assignedInstallerId" [text]="item?.assignedInstallerEmail"> </qds-label>
        <qds-loader *ngIf="isCheckingEmail" size="hero" importance="standard" class="qds-loader"></qds-loader>
        <qds-form-message
          *ngIf="installerEmailValid && !isCheckingEmail"
          text="Installer email recognized"
          status="success"
          style="margin-bottom: 16px"
        ></qds-form-message>
        <qds-form-message
          *ngIf="!installerEmailValid && installerEmail && !isCheckingEmail"
          text="Installer email not recognized"
          status="error"
          style="margin-bottom: 16px"
        ></qds-form-message>
      </div>

      <div *ngIf="deviceLocation">
        <qds-title kicker="Location" level="subsection"> {{ deviceLocation }} </qds-title>
      </div>
      <div *ngIf="!deviceLocation">
        <qds-title kicker="Location" level="section" layer="accessory"> Not Available </qds-title>
      </div>

      <qds-checkbox *ngIf="!item?.assignedInstallerId"
        text="I agree to share my device with selected installer "
        [checked]="isAgreementChecked"
        (qdsChange)="onCheckboxChange($event)"
        style="margin-top: 16px"
      ></qds-checkbox>
      <!-- <qds-checkbox size="small" text="By proceeding with Stop Service, you will revoke the installers access to this Edge device. You will remain the only authorized user and the only one able to restore the installers access. " [checked]="isAgreementChecked" (qdsChange)="onCheckboxChange($event)" style="margin-top: 16px;"></qds-checkbox> -->
      <div *ngIf="item?.assignedInstallerId" style="display: flex; align-items: flex-start; gap: 8px;">
        <qds-checkbox [checked]="isAgreementChecked"  (qdsChange)="onCheckboxChange($event, 'stopService')"> </qds-checkbox>
        <span class="stopServiceInfo">By proceeding with Stop Service, you will revoke the installers access to this Edge device. You will remain the only authorized user and the only one able to restore the installers access.</span>
      </div>
    </div>
    <div class="se-dialog-footer">
      <qds-button id="cancel" text="Cancel" tabindex="0" (click)="onDialogClose()"></qds-button>
      <qds-button
        autofocus=""
        importance="emphasized"
        text="Confirm"
        tabindex="0"
        [disabled]="!isFormValid"
        (click)="onShareConfirm()"
      ></qds-button>
    </div>
  </div>
</div>

<!-- <qds-dialog [open]="isRemoteLinkModal" closable (qdsClose)="onRemoteLinkDialogClose()">
    <qds-title slot="title" layer="popup" [subtitle]="item?.name" level="root"> </qds-title>
    <qds-divider class="w-full" importance="standard" vertical="false" style="margin-top: -27px;"></qds-divider>
    <label class="qds-controls qds-related remoteLink">
      <qds-label inline text="Enter Remote Link:"></qds-label>
      <qds-input class="entredRemoteLink" [value]="entredRemoteLink" (qdsInput)="entredRemoteLink = $event.target.value"></qds-input>
    </label>
    <div slot="footer" style="display: flex; justify-content: flex-end; gap: 8px; width: 100%;">
        <qds-button id="cancel" text="Cancel" tabindex="0" (click)="onRemoteLinkDialogClose()"></qds-button>
        <qds-button autofocus="" importance="emphasized" text="Save" tabindex="0" (click)="saveRex()"></qds-button>
    </div>
</qds-dialog> -->

<div class="se-dialog" *ngIf="isRemoteLinkModal">
  <div class="se-dialog-holder">
    <div class="se-complex-header">
      <h3 class="se-dialiog-title">{{ item?.name }}</h3>
    </div>
    <div class="se-dialog-body">
      <label class="qds-controls qds-related remoteLink">
        <qds-label inline text="Enter Remote Link:"></qds-label>
        <qds-input
          class="entredRemoteLink"
          [value]="entredRemoteLink"
          (qdsInput)="entredRemoteLink = $event.target.value"
        ></qds-input>
      </label>
    </div>
    <div class="se-dialog-footer">
      <qds-button id="cancel" text="Cancel" tabindex="0" (click)="onRemoteLinkDialogClose()"></qds-button>
      <qds-button autofocus="" importance="emphasized" text="Save" tabindex="0" (click)="saveRex()"></qds-button>
    </div>
  </div>
</div>

<div class="se-dialog" *ngIf="isRevokeDeviceModal">
  <div class="se-dialog-holder">
    <div class="se-complex-header">
      <h3 class="se-dialiog-title">{{ item?.name }}</h3>
    </div>
    <div class="se-dialog-body se-dialog-body-delete row-container">
        <img src="assets/warning.svg"/>
        <qds-title layer="popup" level="subsection">{{ labels.revokeDeviceConfirmation  }} </qds-title>
    </div>
    <div class="se-dialog-footer">
      <qds-button id="cancel" text="No" (click)="onRevokeModalClose()"></qds-button>
      <qds-button importance="emphasized" text="Yes" (click)="confirmRevokeDevice(item)"></qds-button>
    </div>
  </div>
</div>